import type { ActionContext } from 'js/lib/ActionContext';

import { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';
import UserNoteGlobalSettingsAPIUtils from 'bundles/account-settings/utils/UserNoteGlobalSettingsAPIUtils';

export const updateHighlightSettings = (
  actionContext: ActionContext,
  {
    userId,
    disableDataAggregation,
    disableTopHighlightsDisplay,
  }: { userId: string; disableDataAggregation: boolean; disableTopHighlightsDisplay: boolean }
) => {
  actionContext.dispatch('SET_UPDATE_STATUS', { updateStatus: UpdateStates.UPDATING });
  UserNoteGlobalSettingsAPIUtils.updateUserNoteGlobalSettings({
    userId,
    disableDataAggregation,
    disableTopHighlightsDisplay,
  })
    .then((response) => {
      const settings = response.elements[0];
      actionContext.dispatch('UPDATE_HIGHLIGHT_SETTINGS', { settings });
    })
    .catch(() => {
      actionContext.dispatch('SET_UPDATE_STATUS', { updateStatus: UpdateStates.FAILED });
    });
};

export const getHighlightSettings = (actionContext: ActionContext, { userId }: { userId: string }) => {
  UserNoteGlobalSettingsAPIUtils.getUserNoteGlobalSettings({ userId })
    .then((response) => {
      const settings = response.elements[0];
      actionContext.dispatch('LOAD_HIGHLIGHT_SETTINGS', { settings });
    })
    .catch((error) => {
      // 404 if user has no settings stored - set default permissions
      if (error.status === 404) {
        const settings = {
          disableDataAggregation: [],
          disableDisplay: [],
        };
        actionContext.dispatch('LOAD_HIGHLIGHT_SETTINGS', { settings });
      }
    });
};
